module.exports = __webpack_public_path__ + "img/fpb-rating-tag.955914aa.png";